import http from "./http";
//查看课程详情 /weChat/applet/course/detail/{courseId}
function courseDetail(courseId){
    let url = `/api/pc/course/detail/${courseId}`;
    return  http.get(url)
}

//收藏课程(如果已经收藏就取消收藏) /weChat/applet/course/collect/course/{courseId}
function collectCourse(courseId){
    let url = `/api/weChat/applet/course/collect/course/${courseId}`;
    return  http.get(url)
}

//获取课程评论   /weChat/applet/comment/commentList/course/{courseId}
// 新接口/pc/comment/commentList/course/{courseId}
function commentList(courseId,pageNumber=1,pageSize=10){
    let url = `/api/pc/comment/commentList/course/${courseId}?pageNum=${pageNumber}&pageSize=${pageSize}`;
    return  http.get(url)
}


//获取章节评论  /weChat/applet/comment/commentList/section/{sectionId}
// 新  api/weChat/applet/comment/commentList/section/{sectionId}
// function commentSectionList(sectionId, pageNumber = 1, pageSize = 10) {
//     let url = `/api/weChat/applet/comment/commentList/section/{sectionId}/${sectionId}?pageNum=${pageNumber}&pageSize=${pageSize}&isAsc=desc&orderByColumn=createdTime`;
//     return http.get(url)
// }
// 获取录播课程的章节评论（pc新接口    /pc/comment/commentList/section/{sectionId}
function commentSectionList(sectionId, pageNumber = 1, pageSize = 10) {
    let url = `/api/pc/comment/commentList/section/${sectionId}?pageNum=${pageNumber}&pageSize=${pageSize}`;
    return http.get(url)
}

//获取直播章节评论 /pc/liveCourseInfo/commentList/section/{sectionId}
//新接口  /pc/comment/commentList/live/section/{sectionId}
function liveOnlineCommentSectionList(sectionId, pageNumber = 1, pageSize = 10) {
    let url = `/api/pc/comment/commentList/live/section/${sectionId}?pageNum=${pageNumber}&pageSize=${pageSize}`;
    return http.get(url)
}

//新加回复评论  /pc/comment/reply/comment?commentId=84
function addreply(commentId, courseId, sectionId, commentContent, score = 5) {
    let url = `/api/pc/comment/reply/comment?commentId=${commentId}`;

    return http.post(url, {
        "sectionId": sectionId,
        "commentContent": commentContent,
        "score": score,
        "courseId": courseId,
    })
}



//添加评论   /weChat/applet/comment/add
function addComment(sectionId,commentContent,score,courseId){
    let url = `/api/weChat/applet/comment/add`;

    return  http.post(url,{
        "sectionId":sectionId,
        "commentContent":commentContent,
        "score":score,
        "courseId":courseId,
    })
}

//删除评论     /weChat/applet/comment/remove/{commentId}
function removeComment(commentId) {
    let url = `/api/weChat/applet/comment/remove/${commentId}`;

    return http.get(url)
}


// 立即学习（进入详情调用）/weChat/applet/course/init/courseStudyDate/{courseId}
function courseStudyDate(courseId){
    let url = `/api/pc/course/init/courseStudyDate/${courseId}`;
    return  http.get(url)
}

//切换章节（换视频时候调用）     /pc/course/switch/section/{sectionId}
function switchSection(sectionId){
    let url = `/api/pc/course/switch/section/${sectionId}`;
    return  http.get(url)
}

// 修改学习进度（页面销毁前，章节切换前）   /weChat/applet/course/change/progress
function changeProgress(learningTime, sectionId, learningProgressId, status) {
    let url = `/api/weChat/applet/course/change/progress`;

    const params = {
        "learningTime":learningTime,
        "sectionId":sectionId,
    }
    if(learningProgressId) params.learningProgressId = learningProgressId
    if (status) params.status = status
    return  http.post(url,params);
}

//获取章节文件  /pc/course/section/file/{sectionId}
function getSectionFile(fatherSectionId) {
    let url = `/api/pc/course/section/file/${fatherSectionId}`;
    return http.get(url)
}

//获取直播章节文件   /pc/liveCourseInfo/liveSection/file/{sectionId}
function getLiveCourseSectionFile(fatherSectionId) {
    let url = `/api/pc/liveCourseInfo/liveSection/file/${fatherSectionId}`;
    return http.get(url)
}


export {
    courseDetail,
    collectCourse,
    commentList,
    addComment,
    courseStudyDate,
    switchSection,
    changeProgress,
    commentSectionList,
    removeComment,
    getSectionFile,
    getLiveCourseSectionFile,
    liveOnlineCommentSectionList,
    addreply
}
